<template>
  <Modal
    id="HolidayEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="holidayForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                    <FormItem :label="$t('holiday.field.holiday_name')" name="holidayName">
                      <Input :placeholder="$t('holiday.validate.required.holiday_name')"
                             v-model:value="form.holidayName">
                      </Input>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('holiday.field.start_date')" name="startDate">
                      <DatePicker valueFormat="YYYY-MM-DD" v-model:value="form.startDate" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('holiday.field.end_date')" name="endDate">
                      <DatePicker valueFormat="YYYY-MM-DD" v-model:value="form.endDate" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('holiday.field.remark')" name="remark">
                      <Textarea
                              v-model:value="form.remark"
                              :placeholder="$t('holiday.validate.required.remark')"
                              :auto-size="{ minRows: 5, maxRows: 10 }"
                              showCount
                      />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { HolidayAdd } from "@/api/HolidayAdd";
import { HolidayEdit } from "@/api/HolidayEdit";


export default {
  name: "HolidayEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idHol : "",
        holidayName : "",
        startDate : "",
        endDate : "",
        remark : "",
      },
      fileList: {
      },
      selectList: {
      },
      validateRules: {
        idHol: [
          {
            required: true,
            message: this.$t("holiday.validate.required.id_hol"),
            trigger: "change",
          },
        ],
        holidayName: [
          {
            required: true,
            message: this.$t("holiday.validate.required.holiday_name"),
            trigger: "change",
          },
        ],
        startDate: [
          {
            required: true,
            message: this.$t("holiday.validate.required.start_date"),
            trigger: "change",
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$t("holiday.validate.required.end_date"),
            trigger: "change",
          },
        ],
        remark: [
          {
            required: false,
            message: this.$t("holiday.validate.required.remark"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
    submit() {
      this.$refs["holidayForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new HolidayAdd();
              break;
            case "edit":
              console.log("edit");
              api = new HolidayEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    // reset data
    _resetData() {
      this.form = {
        idHol : "",
        holidayName : "",
        startDate : "",
        endDate : "",
        remark : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>